'use strict';
export class Alerts {

  constructor (data) {
    this.content = '';
    for (let alertData of data.alerts) {
      this.content += alertData.body;
    }
  }

  /**
   * Render alerts.
   *
   * @return {string}
   *   Alerts HTML.
   */
  renderAlerts() {
    return `
      <div role="alert" class="alert-wrap">
        <div class="header-alert">
          <div class="container container-full-xl">
            <div class="banner__alert__text">
              ${this.content}
            </div>
            <button class="close"><span class="material-icons-outlined">close</span></button>
          </div>
        </div>
      </div>
    `;
  }

  /**
   * Render banner alerts.
   *
   * @return {string}
   *   Alerts HTML.
   */
  renderBannerAlerts() {
    return `
      <div role="alert" class="alert-wrap">
        <div class="banner__alert">
          <button><span class="material-icons-outlined">close</span></button>
          <div class="banner__alert__text">
            ${this.content}
          </div>
        </div>
      </div>
    `;
  }

  /**
   * Close alerts.
   */
  closeAlert() {
    document.querySelectorAll('.alert-wrap').forEach(e => {
      const bannerElement = e.parentNode.parentNode;
      if (bannerElement.classList.contains('alerts-active')) {
        bannerElement.classList.remove('alerts-active');
      }
      e.remove();
    });

    let expires = (new Date(Date.now() + 86400 * 1000)).toUTCString();
    document.cookie = "irexrd-alert-hidden=true; expires=" + expires + ";path=/;domain=." + document.location.hostname + ';';
  }

}

Drupal.behaviors.alerts = {
  attach: function attach(context) {
    const alertsWrapper = once('alerts', '.alerts-wrapper', context);
    let alertCookie = document.cookie.indexOf('irexrd-alert-hidden=true');
    if (alertsWrapper.length && alertCookie === -1) {
      fetch('/api/alerts').then(function(response) {
        return response.json();
      }).then(function(data) {
        if (!data.alerts.length) {
          return;
        }
        const alerts = new Alerts(data);
        let bannerAlertsWrapper = document.querySelector('.alerts-banner-wrapper');
        if (bannerAlertsWrapper) {
          bannerAlertsWrapper.parentNode.classList.add('alerts-active');
          bannerAlertsWrapper.innerHTML += alerts.renderBannerAlerts();
        }
        else {
          alertsWrapper[0].innerHTML += alerts.renderAlerts();
        }

        document.querySelectorAll('.alert-wrap button').forEach((e) => {
          e.addEventListener('click', alerts.closeAlert);
        });
      });
    }
  },
};
